module.exports = __webpack_public_path__ + "static/media/iconChat.41663575.svg";